import * as React from 'react';
import Popup from "reactjs-popup";
import 'reactjs-popup/dist/index.css';

export function Tooltip(props) {
    return (
        <>
            <Popup
                trigger={props.opener}
                position={props.position !== undefined ? props.position : 'top center'}
                on={['hover', 'focus']}
                arrow={props.arrow === false ? false : true}
                className={'tooltip-popup'}
            >
                {React.createElement(props.content)}
            </Popup >
        </>
    );
}
